import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { dynamicComponentSchema, Props, SECTION_TYPE } from '../../model/form.model';


@Component({
  selector: 'app-dashboard-container',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dashboard-container.component.html',
  styleUrl: './dashboard-container.component.scss'
})
export class DashboardContainerComponent implements OnInit{
  @Input() eventId!: number;
  @Input() gridSchema!: Array<dynamicComponentSchema>;
  @Input() props?: Props;
  @Input() tabInfoText?: string;
  public beginRender = false;
  public sectionType=SECTION_TYPE;
  public defaultFilterProps:Props = {
  isSectionFilter: true
  }
  ngOnInit(){
    this.beginRender = true;
  }
}
